module.exports = __webpack_public_path__ + "static/img/medal1.0184824.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/2/medal1.png
// module id = Mo0Q
// module chunks = 1